import React from 'react';
import { Button, useNotify, useRefresh, useRecordContext } from 'react-admin';
import EmailIcon from '@mui/icons-material/MarkEmailRead';

const ResendActivationEmailButton = ({ ...props }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();

  if (!record) return null;

  // Only relevant for users that are not yet activated and have defined a password
  if (record.activated || record.pending_invitation) {
    return null;
  }

  const handleClick = async (e) => {
    e.stopPropagation();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_ENTRYPOINT}/users/${record.id}/resend-activation-email`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

      if (response.status === 400) {
        const data = await response.json().catch(() => ({}));
        notify(data.message || 'Cannot resend activation email for this user', { type: 'warning' });
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      notify('Activation email sent', { type: 'success' });
      refresh();
    } catch (err) {
      notify('Error while sending activation email', { type: 'error' });
    }
  };

  return (
    <Button
      {...props}
      label="Resend activation email"
      onClick={handleClick}
      startIcon={<EmailIcon />}
    />
  );
};

export default ResendActivationEmailButton;
